import axios from 'axios'
import {
  convertBlobToFile,
  STT_SERVICE_MESSAGES,
  toastMessages,
} from '../features/opd/components/constants'
import { toast } from 'react-toastify'
import {
  GET_DOCTORS_ENDPOINT,
  GET_DOCUMENT_BY_ID_DMS_ENDPOINT,
  GET_DOCUMENT_ID_HASURA_ENDPOINT,
} from '../utils/Endpoints'
import KeycloakService from '../utils/keycloakService'

export const postSpeechToText = async (
  blob: Blob,
  visitId: string,
  dmsId: string,
  filename: string
) => {
  const speechToTextServiceUrl = `${process.env.REACT_APP_API_GATEWAY_URL}${process.env.REACT_APP_SPEECH_TO_TEXT_SERVICE_ENDPOINT}`
  const token = KeycloakService.getToken()
  try {
    const audioFile: File = convertBlobToFile(blob, filename)
    const formData = new FormData()
    formData?.append('file', audioFile)
    const payload = { visit_id: visitId, dms_id: dmsId }
    formData?.append('payload', new Blob([JSON.stringify(payload)]))

    const response: any = await axios?.post(speechToTextServiceUrl, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (response?.data) {
      return {
        success: true,
        data: response?.data,
        message: STT_SERVICE_MESSAGES.FileSucess,
      }
    } else {
      return {
        success: false,
        data: null,
        message: STT_SERVICE_MESSAGES.FileError,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message:
        error?.response?.data?.message ||
        error?.message ||
        STT_SERVICE_MESSAGES.FileError,
    }
  }
}

export const getDoctors = async () => {
  const getDoctorsApiUrl = `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DOCTORS_ENDPOINT}`
  const token = KeycloakService.getToken()
  try {
    const response = await axios?.get(getDoctorsApiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response?.data?.data
  } catch (error) {
    toast.error(toastMessages.DoctorFetchError)
    throw error
  }
}

export const opdFormDataFetchApi = async (url: string | null) => {
  const token = KeycloakService.getToken()
  try {
    const response = await axios?.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const body = response?.data?.data ?? {}
    if (body) {
      return {
        success: true,
        data: body,
      }
    } else {
      return {
        success: false,
        data: null,
        message: STT_SERVICE_MESSAGES.FetchError,
      }
    }
  } catch (error) {
    toast.error(toastMessages.Errors, { autoClose: 800 })
    return { success: false, data: null, message: error }
  }
}

export const opdFormDataSaveApi = async (
  url: string,
  payload: Record<string, any>
) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios?.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${url}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getDocumentIdFromHasura = async (encounterId: string | null) => {
  const token = KeycloakService.getToken()
  const payload = { visit_ids: [encounterId] }
  try {
    const response = await axios?.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DOCUMENT_ID_HASURA_ENDPOINT}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    const body = response?.data?.thop_audio_transcriptions ?? {}
    if (body) {
      const affectedRows = body?.affected_rows ?? 0
      return {
        success: true,
        data: body,
        message: `Fetched ${affectedRows} rows.`,
      }
    } else {
      return {
        success: false,
        data: null,
        message: STT_SERVICE_MESSAGES.FetchError,
      }
    }
  } catch (error) {
    toast.error(toastMessages.Errors, { autoClose: 800 })
    return { success: false, data: null, message: error }
  }
}

export const downloadDocumentFromDMSById = async (
  documentId: string | null
) => {
  const dmsToken = sessionStorage.getItem('dms-token')
  try {
    const response = await axios?.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${GET_DOCUMENT_BY_ID_DMS_ENDPOINT}${documentId}`,
      {
        headers: {
          Authorization: `Bearer ${dmsToken}`,
          Accept: '*/*',
        },
        responseType: 'blob',
      }
    )

    if (response.status == 200 && response?.data?.size > 0) {
      return {
        success: true,
        data: response,
        message: `File found. Size ${response?.data?.size} bytes.`,
      }
    } else {
      return {
        success: false,
        data: response,
        message: 'File not found.',
      }
    }
  } catch (error) {
    toast.error(toastMessages.Errors, { autoClose: 800 })
    return { success: false, data: null, message: error }
  }
}
